import { render, staticRenderFns } from "./resumo-dados.vue?vue&type=template&id=5af850f4&scoped=true"
import script from "./resumo-dados.vue?vue&type=script&lang=js"
export * from "./resumo-dados.vue?vue&type=script&lang=js"
import style0 from "./resumo-dados.vue?vue&type=style&index=0&id=5af850f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af850f4",
  null
  
)

export default component.exports